import Grid from '@mui/material/Grid';
import { MarkdownViewer } from "./MarkdownViewer";
import { WikisTreeView } from './WikisTreeView';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react'
import { setSelectedWikiName } from '../../Services/Store/Slices/WikiSlice';
import { setPageUrl } from '../../Services/Store/Slices/WikiPageSlice';
import { useAppDispatch } from '../../Services/Store';

export const WikiPage = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const matches = location.pathname.match('/(?<repository>.*?)%2f');

    if (matches !== null && matches.groups && matches.groups.repository) {
      let repository = decodeURIComponent(matches.groups.repository)
        .replace('+', ' ');

      dispatch(setSelectedWikiName(repository));
      dispatch(setPageUrl(location.pathname.substring(1, location.pathname.length)));
    }
  }, [location, dispatch])

  return (
    <Grid container direction='row' spacing={ 2 }>
      <Grid item xs={ 3 }>
        <WikisTreeView />
      </Grid>
      <Grid item xs={ 9 } >
        <MarkdownViewer />
      </Grid>
    </Grid>
  )
}